import { IPredictionGroupingDto } from 'api/api';
import React, { FC, memo, useMemo } from 'react';
import { localized } from 'state/i18n';
import { PredictionSummaryItem } from './prediction-summary-item';

interface Props {
	data: IPredictionGroupingDto[];
	loading?: boolean;
}

export const PredictionSummary: FC<Props> = memo(({ data, loading }) => {
	const onlyFullWhenEmptied = useMemo(() => {
		return (data || []).filter(pg => pg.fillLevelWhenEmptied === 100 && pg.actualEmptiedDate && pg.predictions);
	}, [data]);

	if (loading) {
		return (
			<div className="d-flex justify-content-center align-items-center" style={{ minHeight: '150px' }}>
				<div className="spinner-border text-primary" role="status">
					<span className="sr-only">Loading...</span>
				</div>
			</div>
		);
	}

	return (
		<div>
			<PredictionSummaryItem label={localized('OverallPredictionDifference')} data={onlyFullWhenEmptied} />
			<PredictionSummaryItem
				label={localized('OneWeekPredictionDifference')}
				data={onlyFullWhenEmptied}
				daysAway={7}
			/>
			<PredictionSummaryItem
				label={localized('3DayPredictionDifference')}
				data={onlyFullWhenEmptied}
				daysAway={3}
			/>
		</div>
	);
});
